import { useState } from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import Layout from '../components/Layout';
import Seo from '../components/Seo';
import { ARTICLES } from '../data/articles';
import { CATEGORIES } from '../data/categories';

export default function Artikler() {
  const [cat, setCat] = useState('');
  const filtered = cat ? ARTICLES.filter((a) => a.category === cat) : ARTICLES;
  return (
    <Layout>
      <Seo
        title="Helseartikler og behandlingsguider | Specialists.no"
        description="Les om private helsebehandlinger i Norge. Guider og råd fra Specialists.no."
        canonical="https://specialists.no/artikler"
      />
      <section className="bg-[#0A1F44] text-white py-14 lg:py-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h1 className="font-display text-4xl lg:text-5xl font-bold">Helseartikler og behandlingsguider</h1>
          <p className="text-white/70 mt-3 text-lg max-w-2xl">Utdypende guider til behandlingene du vurderer.</p>
        </div>
      </section>

      <section className="py-12 lg:py-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex flex-wrap gap-2 mb-10">
            <button onClick={() => setCat('')} className={`px-4 py-2 rounded-full text-sm ${!cat ? 'bg-[#0A1F44] text-white' : 'bg-white border border-[#0A1F44]/10 text-[#0A1F44]'}`}>Alle</button>
            {CATEGORIES.map((c) => (
              <button key={c.slug} onClick={() => setCat(c.name)} className={`px-4 py-2 rounded-full text-sm ${cat === c.name ? 'bg-[#0A1F44] text-white' : 'bg-white border border-[#0A1F44]/10 text-[#0A1F44]'}`}>{c.name}</button>
            ))}
          </div>
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
            {filtered.map((a) => (
              <Link key={a.slug} to={`/artikler/${a.slug}`} className="group bg-white rounded-2xl p-6 border border-[#0A1F44]/10 hover:border-[#0A1F44]/30 hover:-translate-y-1 transition-all">
                <div className="text-[10px] uppercase tracking-[0.15em] font-semibold text-[#3B82F6] mb-3">{a.category} · {a.readingTime} min</div>
                <h3 className="font-display text-xl font-bold text-[#0A1F44] mb-3 leading-tight">{a.title}</h3>
                <p className="text-sm text-[#64748B] line-clamp-3">{a.excerpt}</p>
                <div className="mt-4 flex items-center gap-1 text-sm text-[#3B82F6] font-semibold">Les mer <ArrowRight size={14} /></div>
              </Link>
            ))}
          </div>
        </div>
      </section>
    </Layout>
  );
}
